import axios from 'axios';
import { environment } from '../utils/environment';
import type { User } from 'oidc-client-ts';

const api = axios.create({
  baseURL: environment.API_URL,
  timeout: 30000,
});

let getAccessToken: (() => string | undefined) | null = null;
let signinSilent: (() => Promise<User | void>) | null = null;
let removeUser: (() => Promise<void>) | null = null;

export const setupAxiosInterceptors = (
  getToken: () => string | undefined,
  silentSignin: () => Promise<User | void>,
  userRemove: () => Promise<void>,
) => {
  getAccessToken = getToken;
  signinSilent = silentSignin;
  removeUser = userRemove;
};

api.interceptors.request.use(
  (config) => {
    const token = getAccessToken?.();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      try {
        if (signinSilent) {
          await signinSilent();

          const token = getAccessToken?.();
          if (token) {
            error.config.headers.Authorization = `Bearer ${token}`;
            return api.request(error.config);
          }
        }
      } catch (refreshError) {
        if (removeUser) {
          await removeUser();
        }
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  },
);

export default api;
